var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvertisement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 18.3334V16.5H7.33333V17.4167C7.33333 18.4292 8.15414 19.25 9.16667 19.25H11.9167C12.9292 19.25 13.75 18.4292 13.75 17.4167V15.5834H16.5V16.5C16.5 17.5126 17.3208 18.3334 18.3333 18.3334H20.1667C21.1792 18.3334 22 17.5126 22 16.5V3.66671C22 2.65419 21.1792 1.83337 20.1667 1.83337H3.66667H1.83333C0.820811 1.83337 0 2.65419 0 3.66671V18.3334C0 19.3459 0.820811 20.1667 1.83333 20.1667H3.66667C4.67919 20.1667 5.5 19.3459 5.5 18.3334ZM1.83333 18.3334V3.66671H18.3333H20.1667V16.5H18.3333V12.8334H16.5V13.75H13.75V12.8334H11.9167V17.4167H9.16667V12.8334H7.33333V14.6667H5.5V12.8334H3.66667V18.3334H1.83333ZM17.4167 5.50004V7.33337H4.58333V5.50004H17.4167ZM14.6667 11V9.16671H4.58333V11H14.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertisement);
export default __webpack_public_path__ + "static/media/advertisement.44159af3aae3d2291e1138e68c235103.svg";
export { ForwardRef as ReactComponent };